import React from "react";
import { motion } from "framer-motion";

import { EASE, DURATION } from "../lib/motion";

const GRADIENTS = [
  "from-maroon-700 via-maroon-800 to-brown-900",
  "from-brown-700 via-maroon-700 to-burgundy-700",
  "from-gold-700 via-maroon-800 to-brown-900",
];

export default function LookCard({ item, index = 0 }) {
  const { name, tag, aspect, Icon } = item;
  const gradient = GRADIENTS[index % GRADIENTS.length];

  return (
    <motion.div
      initial={{ opacity: 0, scale: 1.05 }}
      whileInView={{ opacity: 1, scale: 1 }}
      viewport={{ once: true, amount: 0.3 }}
      whileHover={{ scale: 1.02 }}
      transition={{ duration: DURATION, ease: EASE, delay: index * 0.1 }}
      className={`group relative ${aspect} w-full overflow-hidden rounded-sm border border-gold-500/40 shadow-lg break-inside-avoid mb-6`}
    >
      <div
        className={`absolute inset-0 bg-gradient-to-br ${gradient} flex items-center justify-center transition-transform duration-500 group-hover:scale-110`}
      >
        <Icon className="text-cream-100/70 text-5xl sm:text-6xl" />
      </div>
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/0 to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 p-5">
        <p className="font-accent text-gold-300 text-xs tracking-[0.3em] uppercase mb-1">{tag}</p>
        <h3 className="font-heading text-cream-100 text-lg sm:text-xl uppercase tracking-wide leading-tight">
          {name}
        </h3>
      </div>
    </motion.div>
  );
}
